import React, { useState } from "react";
import { Button, CircularProgress, TextField } from "@mui/material";
import useTranslation from "../../hooks/useTranslation";
import feedbackStore from "../../stores/FeedbackStore";
import { FeedbackSeverity } from "../../stores/FeedbackStore/types";

interface CodeValidationProps {
  inputLabel: string;
  sendCodeLabel: string;
  validateCodeLabel: string;
  sendCode: () => Promise<void>;
  validateCode: (code: string) => Promise<boolean>;
  value: boolean;
  setValue: (value: boolean) => void;
}

const CodeValidation = ({
  inputLabel,
  sendCodeLabel,
  validateCodeLabel,
  sendCode,
  validateCode,
  value,
  setValue,
}: CodeValidationProps) => {
  const { t } = useTranslation();
  const [code, setCode] = useState("");
  const [mode, setMode] = useState<"send" | "validate">("send");
  const [loading, setLoading] = useState(false);

  const handleSubmitCode = () => {
    setLoading(true);
    sendCode()
      .then(() => {
        setMode("validate");
      })
      .finally(() => setLoading(false));
    setMode("validate");
  };

  const handleValidateCode = () => {
    setLoading(true);
    validateCode(code)
      .then((result) => {
        if (result) {
          setValue(true);
        } else {
          feedbackStore.setShowFeedback(true, {
            severity: FeedbackSeverity.ERROR,
            message: "wrong-code",
          });
        }
      })
      .finally(() => setLoading(false));
    setMode("validate");
  };

  return (
    <>
      <TextField
        label={t(inputLabel)}
        value={code}
        disabled={loading || mode === "send"}
        onChange={(e) => setCode(e.target.value)}
        InputProps={{
          endAdornment: loading ? (
            <CircularProgress size={"16px"} />
          ) : mode === "send" ? (
            <Button onClick={handleSubmitCode}>{t(sendCodeLabel)}</Button>
          ) : (
            <Button disabled={code === ""} onClick={handleValidateCode}>
              {t(validateCodeLabel)}
            </Button>
          ),
        }}
      />
      <input type="hidden" value={`${value}`} />
    </>
  );
};

export default CodeValidation;
